import { BaseSnapshotProps } from "@custom-types/base-types";
import { SnapshotShareDialog } from "@pages/project-details/project-snapshots/snapshot-share-dialog";
import { useState } from "react";
import { useTrackEvent } from "@utils/track-event/use-track-event";
import { MenuItem, ShareLinkIcon } from "@flat-ui";
import { SnapshotEvents } from "@utils/track-event/track-event-list";

/** Menu item component for sharing a snapshot, used in the snapshot options menu */
export function SnapshotShareMenuItem({
  snapshot,
}: BaseSnapshotProps): JSX.Element {
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const { trackEvent } = useTrackEvent();

  return (
    <SnapshotShareDialog
      snapshot={snapshot}
      isOpen={isDialogOpen}
      onClose={() => setIsDialogOpen(false)}
      location="snapshot-mobile-menu-options"
    >
      <MenuItem
        label="Share"
        Icon={ShareLinkIcon}
        onClick={() => {
          trackEvent({
            name: SnapshotEvents.openShareSnapshot,
            props: {
              snapshotId: snapshot.id,
              accessLevel: snapshot.accessLevel,
              location: "snapshot-mobile-menu-options",
            },
          });

          setIsDialogOpen(true);
        }}
      />
    </SnapshotShareDialog>
  );
}
